import { InjectionToken } from '@angular/core';

/**
 * Injection token for providing the parent HxRadioGroup to child HxRadio components. This allows child radios to
 * communicate with their parent group.
 *
 * @internal
 */
export const HX_RADIO_GROUP = new InjectionToken<any>('HX_RADIO_GROUP');
